import * as React from 'react';
import { cn } from 'lib/utils';

import { PageHeaderForFiltersContext } from './context';
import { FiltersToggleButton } from './filters-toggle-button';

type Props = React.ComponentProps<'div'> & {
  headerTitle?: React.ReactNode | (({ open }: { open: boolean }) => React.ReactNode)
}

export const PageHeaderForFilters = ({
                                       headerTitle,
                                       children,
                                       className,
                                       ...props
                                     }: Props) => {
  const [open, setOpen] = React.useState(false);

  const headerTitleComponent = React.useMemo(() => {
    return typeof headerTitle === 'function'
      ? headerTitle({ open }) : headerTitle;
  }, [open, headerTitle]);

  return (
    <PageHeaderForFiltersContext.Provider
      value={{ open, setOpen }}
    >
      <div
        {...props}
        className={cn(
          'flex flex-col w-full rounded-md bg-white px-6 py-4 shadow-sm shadow-slate-300',
          className,
        )}
      >
        <div className={'flex flex-row items-center'}>
          <div className={'flex flex-row items-center gap-2 grow pr-4'}>
            {headerTitleComponent}
          </div>
          <FiltersToggleButton className={'ml-auto h-[30px]'} />
        </div>
        <div
          className={cn(
            'border-t-slate-300 border-t pt-6 mt-4 hidden',
            open && 'flex',
          )}
        >
          {children}
        </div>
      </div>
    </PageHeaderForFiltersContext.Provider>
  );
};
